export enum OWNERSHIP_OPTIONS {
  OWN = "own",
  RENT = "rent",
  RENT_FREE = "rent_free",
}

const ownershipOptions = [
  { label: "Own", value: OWNERSHIP_OPTIONS.OWN },
  { label: "Rent", value: OWNERSHIP_OPTIONS.RENT },
  { label: "Rent Free", value: OWNERSHIP_OPTIONS.RENT_FREE },
];

export { ownershipOptions };
